module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "profile"
  }, [_c('sui-header'), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_vm._l((_vm.chatRoomListing), function(chatRoom) {
    return [_c('article', {
      staticClass: "media"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "media-content"
    }, [_c('div', {
      staticClass: "content max-lines--one-plus-three"
    }, [_c('p', [_c('router-link', {
      attrs: {
        "to": {
          name: 'chatroom',
          params: {
            chatRoomId: chatRoom.chatRoomId
          }
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(chatRoom.title))])]), _vm._v(" "), _c('small', [_vm._v("(" + _vm._s(chatRoom.counts.participants) + " members)")]), _vm._v(" "), _c('br'), _vm._v(" "), (chatRoom.preview) ? _c('span', [_vm._v("\n                      " + _vm._s(chatRoom.preview.content) + "\n                    ")]) : _c('span', [_c('small', [_c('i', [_vm._v("no messages")])])])], 1)])]), _vm._v(" "), _c('div', {
      staticClass: "media-right"
    }, [(chatRoom.preview) ? _c('p', [_c('strong', [_vm._v("\n                    " + _vm._s(_vm.timeFromTimestamp(chatRoom.preview.timestamp)) + "\n                  ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("\n                    " + _vm._s(_vm.dateFromTimestamp(chatRoom.preview.timestamp)) + "\n                  ")])]) : _vm._e()])])]
  })], 2)])])]), _vm._v(" "), _c('sui-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "media-left"
  }, [_c('p', {
    staticClass: "image is-64x64 sui-avatar"
  }, [_c('img', {
    attrs: {
      "src": "http://placehold.it/64x64"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-6c4b53ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChatRoomListing.vue
// module id = 287
// module chunks = 1